/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Wizard_SkipInputs */

const cs_portals_wizard_skip = /** @type {(inputs: Portals_Wizard_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přeskočit`)
};

const en_portals_wizard_skip = /** @type {(inputs: Portals_Wizard_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip`)
};

/**
* | output |
* | --- |
* | "Skip" |
*
* @param {Portals_Wizard_SkipInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_wizard_skip = /** @type {((inputs?: Portals_Wizard_SkipInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Wizard_SkipInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_wizard_skip(inputs)
	return cs_portals_wizard_skip(inputs)
});